import { isArray, isObject } from "lodash";

export const formatUsers = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.name} ${data.surname}`,
      value: data._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.name} ${data.surname}`
    };
  }
};

export const formatAlerts = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.title}`,
      value: data._id,
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.title}`,
    };
  }
};

export const formatShopCarts = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((item) => ({
      ...item,
      label: item.name || item.title || item._id,
      value: item._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: data.name || data.title || data._id
    };
  }
};

export const formatArticles = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((item) => ({
      ...item,
      label: item.name || item.description || item._id,
      value: item._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: data.name || data.description || data._id
    };
  }
};

export const formatRepartidors = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((item) => ({
      ...item,
      label: item.name || item.title || item._id,
      value: item._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: data.name || data.title || data._id
    };
  }
};

export const formatRepartiments = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((item) => ({
      ...item,
      label: item.no || item.number || item._id,
      value: item._id || item.no
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id || data.no,
      label: data.no || data.number || data._id
    };
  }
};

export const formatInvoices = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((item) => ({
      ...item,
      label: item.no || item.number || item._id,
      value: item._id || item.no
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id || data.no,
      label: data.no || data.number || data._id
    };
  }
};
